import { render } from "./Roles.vue?vue&type=template&id=afdf7244&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=afdf7244&scoped=true&lang=css"
import "./Roles.vue?vue&type=style&index=1&id=afdf7244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdf7244"]])

export default __exports__